
<section class="date-picker">
  <date-picker class="datePicker" ref="datePicker" v-model:value="state.time" :lang="state.langType"
  type="date"  :editable="true"
  range prefix-class="xmx"  format="YYYY/MM/DD" v-model:open="state.open" @confirm="datePickerConfirm"
  :disabled="isDisable" @close="closePicker"
  :confirm="true" confirm-text="Apply" @pick="calendarChange">
    <template #footer="{ emit }">
      <div class="datePicker-footer">
        <div class="timeBlock">
          <div v-for="(e,i) in selectVal" >
            <div >{{timePick(e, emit)}}</div>
            <div v-if="i == 0">  ~  </div>
          </div>
        </div>
        <div class="datePickerButtonBlock">
          <Button @onClick="applyDate(emit)" type="full" style="margin-right: 24px;" wd="ssmd" h="smd" :disable="state.temp.length!=2" :text="t('__common.__apply')" class="buttonEach"></Button>
          <Button @onClick="closePicker" type="border"  wd="ssmd" h="smd" :text="t('__common.__cancel')" class="buttonEach aaa"></Button>
        </div>
      </div>
    </template>
  </date-picker>
  <!-- <div>time : {{state.time}}</div> -->
  <div :class="{'erroSpan' : error}" v-if="error"> {{error}}</div>
</section>

